export default "__VITE_ASSET__2b62e058__"